import { useHistory } from 'react-router-dom';
import { ComponentSectionContextType } from '../../../../types/context';
import { useFormTokenChainContext } from '../../../context/useFormTokenChainContext';
import useRoutes from '../../../useRoutes';
import { displayConfirmationModal } from '../displayConfirmationModal';
import { getResolvedRowsToUse } from '../getResolvedRowsToUse';
import { useControlActionModalContent } from '../../../useControlActionModalContent';
import { navigateToForm } from '../navigateToForm';

export const getFormTypeCallback = (
  dataset: any,
  rowsToUse: any[],
  selectedVirtualRows: number,
  deselectedRowIds: Set<string>,
  control: any,
  componentSection: ComponentSectionContextType['componentSection'],
  routes: ReturnType<typeof useRoutes>,
  rootDataset: any,
  slaveTabIndex: number,
  fromPathname: string,
  fromItemExternalUrl: boolean | undefined,
  masterExpandedRow: any,
  referenceDatasetId: string | undefined,
  itemId: string | undefined,
  history: ReturnType<typeof useHistory>,
  token: string | null,
  fetchDatasetData: () => Promise<any[]>,
  getActualTokenFromUrl: ReturnType<
    typeof useFormTokenChainContext
  >['getActualTokenFromUrl'],
  createRootToken: ReturnType<
    typeof useFormTokenChainContext
  >['createRootToken'],
  createNestedToken: ReturnType<
    typeof useFormTokenChainContext
  >['createNestedToken'],
  openControlModal: ReturnType<typeof useControlActionModalContent>['open'],
  closeControlModal: ReturnType<typeof useControlActionModalContent>['close'],
  setModalLoading: ReturnType<
    typeof useControlActionModalContent
  >['setModalLoading']
) => {
  return async () => {
    try {
      const shouldDisplayConfirmationModal = displayConfirmationModal(
        control,
        rowsToUse
      );

      if (shouldDisplayConfirmationModal) {
        setModalLoading(true);
      }

      const resolvedRowsToUse: any[] = await getResolvedRowsToUse(
        dataset,
        rowsToUse,
        selectedVirtualRows,
        fetchDatasetData,
        deselectedRowIds
      );

      const proceed = () =>
        navigateToForm(
          componentSection,
          routes,
          history,
          dataset,
          control,
          rootDataset,
          resolvedRowsToUse,
          slaveTabIndex,
          fromPathname,
          fromItemExternalUrl,
          masterExpandedRow,
          getActualTokenFromUrl,
          createRootToken,
          createNestedToken,
          token,
          referenceDatasetId,
          itemId,
          shouldDisplayConfirmationModal ? closeControlModal : undefined
        );

      if (shouldDisplayConfirmationModal) {
        setModalLoading(false);
        return openControlModal(dataset, control, resolvedRowsToUse, proceed);
      }

      proceed();
    } catch (error) {
      setModalLoading(false);
      throw error;
    }
  };
};
